(function (angular) {
    'use strict';

    angular.module('Toyota.Directives')
        .directive('gtmForm', [function () {
            gtmFormController.$inject = ['$scope', '$element', '$analytics', 'GtmDetails', '$parse'];
            function gtmFormController($scope, $element, $analytics, GtmDetails, $parse) {
                var gfc = this;

                function init() {
                    // This function helps avoiding overriding an existing property value if is already there and is some valid value
                    function getPropertyLabel(propertyValue, controlValue) {
                        if (!propertyValue || propertyValue.toLowerCase() === 'not completed') {
                            return controlValue;
                        }
                        return propertyValue;
                    }

                    function getFieldProperty(gtmDetails, properties) {
                        var property = {};

                        if (gtmDetails.formSubmitProp) {
                            property[gtmDetails.formSubmitProp] = getPropertyLabel(properties[gtmDetails.formSubmitProp], gtmDetails.label);
                        }
                        else {
                            property[gtmDetails.action] = getPropertyLabel(properties[gtmDetails.action], gtmDetails.label);
                        }

                        return property;
                    }

                    function getExtraFieldProperty(gtmDetails, properties) {
                        var property = {};
                        if (gtmDetails.extraFormSubmitProp && Object.keys(gtmDetails.extraFormSubmitProp)) {
                            Object.keys(gtmDetails.extraFormSubmitProp).forEach(function (fieldName) {
                                property[fieldName] = gtmDetails.extraFormSubmitProp[fieldName];
                            });
                        }
                        return property;
                    }

                    function fireGtm() {
                        var gtmFormLabelDynamic = gfc.gtmFormLabelBind && $parse(gfc.gtmFormLabelBind)($scope);

                        var properties = {
                            eventCategory: gfc.gtmFormCategory || 'form submission',
                            eventAction: gfc.gtmFormName,
                            eventLabel: gtmFormLabelDynamic || gfc.gtmFormLabel || '',
                            formName: gfc.gtmFormSubmitName
                        };

                        var fields = $element.find('[data-gtm-form-submission]');
                        fields.each(function (index, fieldElement) {
                            var gtmDetails = GtmDetails(fieldElement);

                            if (gtmDetails.controlType === 'button' && fieldElement.checked) {
                                angular.extend(properties, getFieldProperty(gtmDetails, properties));
                                angular.extend(properties, getExtraFieldProperty(gtmDetails, properties));
                            }
                            else if (gtmDetails.controlType !== 'button') {
                                angular.extend(properties, getFieldProperty(gtmDetails, properties));
                                angular.extend(properties, getExtraFieldProperty(gtmDetails, properties));
                            }
                        });

                        if (gfc.gtmFormAnalyticsGetExtraProps) {
                            angular.extend(properties, gfc.gtmFormAnalyticsGetExtraProps());
                        }
                        var formSubmitEventName = gfc.gtmFormSubmitEventName || 'gaFormSubmission';

                        $analytics.eventTrack(formSubmitEventName, properties);
                    }

                    $scope.$on('form-success', function () {
                        fireGtm();
                    });
                }

                init();
            }

            return {
                restrict: 'A',
                controller: gtmFormController,
                controllerAs: 'gfc',
                bindToController: {
                    gtmFormName: '@gtmFormName',
                    gtmFormSubmitEventName: '@gtmFormSubmitEventName',
                    gtmFormSubmitName: '@gtmFormSubmitName',
                    gtmFormCategory: '@gtmFormCategory',
                    gtmFormLabel: '@gtmFormLabel',
                    gtmFormLabelBind: '@gtmFormLabelBind',
                    gtmFormAnalyticsGetExtraProps: '&gtmFormAnalyticsGetExtraProps'
                },
                link: function (scope, element, attrs) {

                }
            };
        }]);
})(window.angular);
